import { createLabeledMessages, unitJoin } from '../../../messageUtils';
const car = {
    registrationNumber: 'registration number',
    registrationNumber_short: 'RZ',
    vin: 'VIN',
    technicalCertificateCard: 'technical certificate card',
    technicalCertificateCard_short: 'TP',
    technicalCertificate: 'technical certificate',
    technicalCertificate_short: 'VTP',
    type: 'type',
    usage: 'usage',
    engineCapacity: 'engine capacity',
    engineCapacityCcm: unitJoin('car:engineCapacity_label', 'ccm'),
    weight: 'weight',
    weightKg: unitJoin('car:wight', 'kg'),
    startDate: 'entry into service',
    model: 'model',
    manufacturer: 'manufacturer',
    body: 'body',
    door: 'door',
    manufacturedFrom: 'manufactured from',
    manufacturedTo: 'manufactured to',
    seedCount: 'seat count',
    transmission: 'transmission',
    fuel: 'fuel',
    pov: 'compulsory insurance',
    poc_short: 'POV',
    hav: 'crash insurance',
    hav_short: 'HAV'
};
export default Object.assign({}, car, createLabeledMessages(car));
